// Pantalla de carga del formulario de inscripción rediseñado (v2): tarjeta centrada con la U de
// CUC dentro de un anillo que gira y una barra de progreso animada.
import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import simbolo from "../../../global/imagenes/logo_u_cuc.png";
import { useEstilosInscripcion } from "./estilosInscripcion";
import { PieInscripcion } from "./componentesInscripcion";

export default function CargandoInscripcion() {
  const classes = useEstilosInscripcion();
  return (
    <div className={classes.raiz}>
      <CssBaseline />
      <main className={`${classes.pagina} ${classes.cierrePagina}`}>
        <div className={classes.cargandoTarjeta} role="status" aria-live="polite">
          <div className={classes.cargandoIndicador}>
            <div className={classes.cargandoAnillo} />
            <img src={simbolo} alt="" className={classes.cargandoSimbolo} />
          </div>
          <p className={classes.cargandoTitulo}>Preparando tu formulario</p>
          <p className={classes.cargandoTexto}>Esto tomará solo un momento</p>
          <div className={classes.cargandoBarra}>
            <span />
          </div>
        </div>
      </main>
      <PieInscripcion />
    </div>
  );
}
